import { render, staticRenderFns } from "./audioDialog.vue?vue&type=template&id=142bd889&scoped=true&"
import script from "./audioDialog.vue?vue&type=script&lang=ts&"
export * from "./audioDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142bd889",
  null
  
)

export default component.exports